import { render, staticRenderFns } from "./NewEditAulaPage.vue?vue&type=template&id=3bb78820&scoped=true"
import script from "./NewEditAulaPage.vue?vue&type=script&lang=js"
export * from "./NewEditAulaPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditAulaPage.vue?vue&type=style&index=0&id=3bb78820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb78820",
  null
  
)

export default component.exports